import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportCognismContactsMutation,
  ExportCognismContactsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportCognismContacts = graphql(`
  mutation exportCognismContacts(
    $input: ExportCognismContactsInput!
    $exportFormat: ExportFormatArgs!
  ) {
    exportCognismContacts(input: $input, ExportFormat: $exportFormat) {
      id
      revealedCount
      suppressedCount
      failedCount
      chargedCount
    }
  }
`);

export function useExportCognismContacts(
  options?: UseMutationOptions<
    ExportCognismContactsMutation,
    unknown,
    ExportCognismContactsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();
  const { data, ...rest } = useGraphQlMutation(exportCognismContacts, {
    ...options,
    onSuccess: (mutationData, variables, context) => {
      options?.onSuccess?.(mutationData, variables, context);
      // Credits are charged synchronously during the export → refresh the balance meter and the
      // usage history behind it. Positional key is TanStack Query v4; a v5 upgrade would need
      // `invalidateQueries({ queryKey: [...] })`.
      void queryClient.invalidateQueries(["contactsExportCredits"]);
      void queryClient.invalidateQueries(["contactsCreditUsageHistory"]);
    },
  });
  return { data: data?.exportCognismContacts, ...rest };
}
